import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.GET_ALL_FAVORITE_FORMULAS:
            if (!responseHelper.isGetAllFavoriteFormulasFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FAVORITE_FORMULA_LIST,
                    payload: {
                        favoritesList: response.data[0]
                    }
                }
            ];
        case handlers.ADD_FAVORITE_FORMULA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                }
            ];
        case handlers.REMOVE_FAVORITE_FORMULA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                }
            ];
        case handlers.ADD_FAVORITE_FOLDER:
            if (!responseHelper.isAddFavoriteFolderFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                },
                {
                    type: actionTypes.SELECT_TAB_FAVORITE_FOLDER,
                    payload: {
                        name: response.data.name,
                        parentId: response.data.parentId,
                        folderId: response.data.id
                    }
                }
            ];
        case handlers.EDIT_FAVORITE_FOLDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                }
            ];
        case handlers.MOVE_FAVORITE_FORMULA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                }
            ];
        case handlers.REMOVE_FAVORITE_FOLDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FAVORITE_FORMULAS
                    },
                    method: handlers.GET_ALL_FAVORITE_FORMULAS,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.DELETE_FAVORITE_FOLDER_MODAL
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
